import React, { createContext, useState, useEffect, useMemo } from "react"
import UserTableTitle from "../../constants/UserTableTitle.json"
import API from "../../api/api"
// import TestuserData from "../../test/serviceProvidersList.json"
import { db } from "../../helpers/firebase_helper"

export const ServiceProvidersContext = createContext()

export const ServiceProvidersContextProvider = ({ children }) => {
  const [serviceProviderData, setServiceProviderData] = useState([""])
  const [totalPagesCount, setTotalPagesCount] = useState(0)
  const [userDataBackup, setUserDataBackup] = useState()
  const [pageNumberThreshold, setPageNumberThreshold] = useState(0)

  /**
   * Get service providers list from db
   */
  const getServiceProvidersList = async () => {
    let fullUserList = []
    const snapshot = await db.collection("users").get()
    snapshot.forEach(doc => {
      const snapshotDashboard = doc
      const userDoc = { ...snapshotDashboard.data(), id: doc.id }
      fullUserList.push(userDoc)
    })

    const fileteredData = fullUserList.filter(item => {
      if (item.serviceProvider) return item
    })

    const totalPages = Math.ceil(fileteredData.length / 10)
    setPageNumberThreshold(0)
    setTotalPagesCount(totalPages)
    setUserDataBackup(fileteredData)
    setServiceProviderData(fileteredData.slice(0, 10))
  }

  const nextPage = async currentPageNumber => {
    setPageNumberThreshold((currentPageNumber - 1) * 10)
    const startIndex = (currentPageNumber - 1) * 10
    const endIndex = currentPageNumber * 10
    const results = userDataBackup.slice(startIndex, endIndex)
    setServiceProviderData(results)
  }

  useEffect(() => {
    getServiceProvidersList()
  }, [])

  const providerValue = {
    serviceProviderData,
    UserTableTitle,
    nextPage,
    totalPagesCount,
    pageNumberThreshold,
  }

  return (
    <ServiceProvidersContext.Provider value={providerValue}>
      {children}
    </ServiceProvidersContext.Provider>
  )
}
